import { keyBy, reduce } from "lodash"
import { theme } from "twin.macro"

export const CAMPAIGN_STATUSES = [
    {
        key: 0,
        label: "Not Scheduled",
        labelColor: theme`colors.red600`,
        bg: theme`colors.red200`,
        color: theme`colors.red600`
    },
    {
        key: 1,
        label: "Pending Approval",
        labelColor: theme`colors.indigo600`,
        bg: theme`colors.indigo200`,
        color: theme`colors.indigo600`
    },
    {
        key: 2,
        label: "Partially Scheduled",
        labelColor: theme`colors.yellow800`,
        bg: theme`colors.yellow200`,
        color: theme`colors.yellow800`
    },
    {
        key: 3,
        label: "Scheduled",
        labelColor: theme`colors.teal600`,
        bg: theme`colors.teal200`,
        color: theme`colors.teal800`
    }
]

export const CAMPAIGN_STATUS_MAP = keyBy(CAMPAIGN_STATUSES, "key")
export const CAMPAIGN_STATUS = reduce(
    CAMPAIGN_STATUSES,
    (acc, crr) => ({ ...acc, [String(crr.key)]: crr.key }),
    {}
)
